import NotFoundPage from '@brands/Dashboard/NotFoundPage/NotFoundPage';
import ImageUploadStepFour from '@brands/Dashboard/PatientForms/PatientForm/ImageUpload/ImageUploadStepFour';
import { selectAuth } from '@brands/store/selectors/auth';
import { AuthState } from '@brands/store/slices/authSlice';
import React from 'react';

import ImageUploadStepFourAdminView from '../../../../../default/Dashboard/PatientForms/PatientForm/ImageUpload/ImageUploadStepFour';
import { useAppSelector } from '../../../../hooks/useReduxHook';
import { UserRoleName } from '../../../../services/identity/types/UserProfile';

const ImageUploadStepFourValidation: React.FC = () => {
  let component: JSX.Element;
  const user: AuthState = useAppSelector(selectAuth);

  switch (user.userInfo?.role.name) {
    case UserRoleName.Patient:
    case UserRoleName.Collector:
    case UserRoleName.CareAdvisor:
      component = <ImageUploadStepFour />;
      break;
    case UserRoleName.OrganizationAdmin:
    case UserRoleName.SuperAdmin:
    case UserRoleName.Admin:
      component = <ImageUploadStepFour />;
      break;
    default:
      component = <NotFoundPage />;
      break;
  }

  return <div>{component}</div>;
};

export default ImageUploadStepFourValidation;
